import { Dialog } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'

import DeleteFilterIcon from '../../../../assets/images/icons/delete-filter-icon.svg?react'
import XIcon from '../../../../assets/images/icons/x-close-filter.svg?react'

type Props = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  filterName?: string
  onConfirm: () => void
}

export default function FilterDeleteConfirmModal({
  isOpen,
  setIsOpen,
  filterName,
  onConfirm,
}: Props) {
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-50"
    >
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{
          background: 'rgba(41, 41, 41, 0.7)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100">
          <div className="flex flex-col p-6 w-96">
            <div className="flex flex-col items-center">
              <div className="flex flex-row justify-center w-full">
                <DeleteFilterIcon />
                <button
                  type="button"
                  className="absolute right-8 border-0 rounded-full p-2 active:bg-gray-100"
                  onClick={() => setIsOpen(false)}
                >
                  <XIcon />
                </button>
              </div>

              <h1 className="font-medium text-lg text-gray-900 pt-5 pb-2">
                Delete filter
              </h1>
              <p className="font-normal text-sm text-gray-500 text-center pb-5">
                Are you sure you want to delete
                {filterName ? (
                  <>
                    {' '}
                    <span className="font-medium text-gray-700">
                      "{filterName}"
                    </span>
                  </>
                ) : (
                  ' this filter'
                )}
                ? This action cannot be undone.
              </p>

              <div className="flex flex-row items-end w-full space-x-3">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="h-11 w-full flex justify-center items-center border border-solid border-gray-300 rounded-lg active:bg-gray-100"
                >
                  <span className="font-medium text-base text-gray-700">
                    Cancel
                  </span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsOpen(false)
                    onConfirm()
                  }}
                  className="h-11 w-full flex justify-center items-center bg-error-600 border border-solid border-error-600 rounded-lg active:bg-error-700"
                >
                  <span className="font-medium text-base text-white-100">
                    Delete
                  </span>
                </button>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
